import { render, staticRenderFns } from "./SiteHeader.vue?vue&type=template&id=18a8f222&scoped=true"
import script from "./SiteHeader.vue?vue&type=script&lang=ts"
export * from "./SiteHeader.vue?vue&type=script&lang=ts"
import style0 from "./SiteHeader.vue?vue&type=style&index=0&id=18a8f222&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a8f222",
  null
  
)

export default component.exports